'use client';

import { c as _c } from "react/compiler-runtime";
import { SessionProvider } from 'next-auth/react';
import type { SessionProviderProps } from 'next-auth/react';
export const NextAuthProvider = t0 => {
  const $ = _c(6);
  let children;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = rest;
  } else {
    children = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== rest) {
    t1 = <SessionProvider {...rest}>{children}</SessionProvider>;
    $[3] = children;
    $[4] = rest;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};